export function checkScreenSize(): boolean {
    return window.innerWidth < 768;
}
